export default __webpack_public_path__ + "static/media/missing_floor_plan_en.1696ab38.svg";